import classNames from 'classnames';
import * as React from 'react';
class TextField extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            focused: false,
        };
        this.onBlur = (e) => {
            this.setState({
                focused: false,
            });
            if (this.props.onBlur) {
                this.props.onBlur(e.target.value);
            }
        };
        this.onFocus = (e) => {
            this.setState({
                focused: true,
            });
            if (this.props.onFocus) {
                this.props.onFocus(e.target.value);
            }
        };
    }
    render() {
        const { className, hasError, isValid, multiline, onChange = () => void 0, optimisticUpdate, showErrorsInFocus, showIsValidInFocus, type, value, innerRef, ...rest } = this.props;
        const inputClasses = classNames('ixu-textfield', className, {
            'ixu-textfield--search': type === 'search',
            'ixu-textfield--multiline': !!multiline,
            'is-error': !!hasError && (showErrorsInFocus || !this.state.focused),
            'is-success': !!isValid && !hasError && (showIsValidInFocus || !this.state.focused),
        });
        const HTMLTag = multiline ? 'textarea' : 'input';
        return (React.createElement(HTMLTag, { ...rest, className: inputClasses, defaultValue: optimisticUpdate ? value : undefined, onBlur: this.onBlur, onChange: (e) => onChange(e.target.value), onFocus: this.onFocus, ref: innerRef, type: type, value: !optimisticUpdate ? value : undefined }));
    }
}
TextField.defaultProps = {
    hasError: false,
    multiline: false,
    showErrorsInFocus: false,
    type: 'text',
    value: '',
};
export default TextField;
//# sourceMappingURL=TextField.js.map